import { Component, ViewChild } from "@angular/core";
import { ColumnBase } from "@progress/kendo-angular-grid";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { EntityListAction, Permission, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { RowAccessKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { GridFilter, LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { takeUntil } from "rxjs/operators";
import { RowAccessComponent } from "src/app/gnr/row-access/row-access.component";
import { SubLedger } from "../../models/subledger.model";
import { SubLedgerImportExcelFormComponent } from "../sub-ledger-import-excel/sub-ledger-import-excel-form.component";
import { SubLedgerFormComponent } from "../subledger-form/subledger-form.component";

@Component({
  selector: "ngx-subledger-list",
  templateUrl: "./subledger-list.component.html",
  styleUrls: ["./subledger-list.component.scss"],
})
export class SubLedgerListComponent extends BaseListComponent {
  @ViewChild("grid") grid: KGridComponent;
  HasRowAccess: boolean;
  get detailLedgerLevel(): number {
    return this.missetup.getnumber("ACC", "DLLEVEL");
  }
  constructor(private missetup: MisSetupService, private lookupservice: LookupService) {
    super();
    this.inputEditorform = SubLedgerFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    if (this.HasRowAccess === undefined) {
      this.HasRowAccess = this.missetup.getboolean("GNR", "HasRowAccess");
    }
    this.apiName = "SubLedger";
    this.areaName = "Accounting";
    this.label = this.translate("ClientApp.BackOffice.ACC.SubLedger.SubLedger");
    this.setColumns();
    this.setactions();
  }

  ngOnDestroy(): void {}
  setColumns() {
    this.httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (data) {
          this.columns = data as form_control[];
          this.setColumnAttribute();
          this.columns = (data as form_control[]).filter(
            (f) => ((!f.areaName || f.areaName === "default") && f.listVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
          );
          this.columns = this.columns.sort((a, b) => a.order - b.order);
        }
      });
  }
  setColumnAttribute() {
    const dlLevel = this.detailLedgerLevel;
    this.columns.forEach((x) => {
      if (x.name === "HasDetailLedger1") x.listVisible = dlLevel >= 1;
      if (x.name === "HasDetailLedger2") x.listVisible = dlLevel >= 2;
      if (x.name === "HasDetailLedger3") x.listVisible = dlLevel >= 3;
      if (x.name === "HasDetailLedger4") x.listVisible = dlLevel >= 4;
      if (x.name === "HasDetailLedger5") x.listVisible = dlLevel >= 5;
      if (x.name === "HasDetailLedger6") x.listVisible = dlLevel >= 6;
      if (x.name === "HasDetailLedger7") x.listVisible = dlLevel >= 7;
    });
  }
  setactions() {
    this.actions = [
      {
        name: "ImportFromExcel",
        disabled: false,
        displayName: "ورودی اکسل",
        iconName: "icon-file-excel-o",
        apiName: "GroupLedger/ImportExcel",
        areaName: "Accounting",
        Form_Component: SubLedgerImportExcelFormComponent,
        permission: Permission.samePermission,
      },
    ];
    if (this.HasRowAccess === true)
      this.actions.push({
        name: "RowAccess",
        disabled: false,
        displayName: "دسترسی در ردیف",
        iconName: "icon-users",
        apiName: "SubLedger/RowAccess",
        areaName: "Accounting",
        requireSelectedrows: true,
        Form_Component: RowAccessComponent,
        permission: Permission.samePermission,
      });
  }
  onActionClick(action: EntityListAction, onRowSelected: SubLedger, onRowsSelected: SubLedger[], isAllSelected: boolean, gridFilter: GridFilter[]) {
    if (action.name === "RowAccess") {
      let ids: number[] = [];
      if (onRowsSelected != null && onRowsSelected.length > 0) {
        onRowsSelected.forEach((x) => ids.push(x.Id));
      } else ids.push(onRowSelected.Id);
      this.lookupservice
        .getLookupbyCode("Security", "RowAccess", RowAccessKind.SubLedger)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.dialogService
              .open(
                action.Form_Component,
                {
                  SelectedRows: ids,
                  RowKindId: x.Id,
                },
                {
                  autoFocus: true,
                  closeOnClickOutside: false,
                }
              )
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((model: GridFilter[]) => {});
          },
          (error) => {}
        );
    }
    if (action.name === "ImportFromExcel") {
      var gridInfo = this.getGridInfo(this.grid.grid.columns.toArray());
      this.dialogService
        .open(
          action.Form_Component,
          {
            gridInfo: gridInfo,
            label: action.displayName,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: GridFilter[]) => {});
    }
  }
  getParamsForExportExcelWithPostMethod(): Promise<any> {
    return new Promise((resolve, reject) => {
      resolve(this.getGridInfo(this.grid.grid.columns.toArray()));
    });
  }

  getGridInfo(columns: ColumnBase[]): GridColumnInfoDetail[] {
    return columns
      .filter((x) => !x.hidden)
      .map((x) => {
        const info = new GridColumnInfoDetail();
        info.name = x["field"];
        info.hidden = x.hidden;
        info.orderindex = x.orderIndex;
        info.title = x.title;
        return info;
      });
  }
}
